import React, { useCallback, useEffect, useRef } from 'react'

import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { GridStyled, Loading } from '@atoms'
import { Page } from '@templates'
import { useAuth, useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import routes from '@routes/routes'
import { contratosRequest } from '@store/refinanciamento/contratos/actions'
import { ApplicationState } from '@store/types'
import { authenticationRequest } from '@store/refinanciamento/authentication/actions'

const VerificacaoRedirecionamento = () => {
  const navigate = useNavigate()
  const { getToken, accessToken } = useAuth()
  const dispatch = useDispatch()

  useTrackingRefin(StepRefin.VERIFICACAO)
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const hasStarted = useRef(false)
  const handleContratosRequest = useCallback(() => {
    dispatch(
      contratosRequest({
        semContratosCallback: () => {
          navigate(routes.SEM_EMPRESTIMO)
        },
        successCallback: () => {
          navigate(routes.CONTRATOS)
        },
      }),
    )
  }, [navigate, dispatch])

  useEffect(() => {
    if (hasStarted.current) return
    hasStarted.current = true

    if (!isApp && !accessToken) {
      getToken()
    } else if (!isApp && accessToken) {
      handleContratosRequest()
      dispatch(authenticationRequest())
    }
  }, [isApp, accessToken, getToken, navigate, handleContratosRequest, dispatch])

  return (
    <Page>
      <GridStyled margin="40vh 0 0">
        <Loading width={50} height={50} />
      </GridStyled>
    </Page>
  )
}

export default VerificacaoRedirecionamento
